import React from "react";
import { Grid, Stepper, Step, StepLabel, AvatarGroup, Avatar } from "@mui/material";

function ProgressBar({ currentStep, totalSteps, score }) {
  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={10}>
        <Stepper activeStep={currentStep} alternativeLabel>
          {Array.from({ length: totalSteps }).map((_, index) => (
            <Step key={index}>
              <StepLabel>{index + 1}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Grid>
      <Grid item xs={2}>
        <AvatarGroup spacing="medium">
          <Avatar sx={{ bgcolor: "success.main" }}>{score}</Avatar>
          <Avatar sx={{ bgcolor: "text.secondary" }}>{totalSteps}</Avatar>
        </AvatarGroup>
      </Grid>
    </Grid>
  );
}

export default ProgressBar;
